import { VehicleList } from "./VehicleList";

export function CarsList() {
  return (
    <VehicleList
      resource="cars"
      noEntriesText="Noch kein PKW hinterlegt."
      noMatchingEntriesText="Keine passenden PKWs gefunden."
    />
  );
}
